import { render } from "./GilgitBaltistan.vue?vue&type=template&id=de07d14e&scoped=true"
const script = {}

import "./GilgitBaltistan.vue?vue&type=style&index=0&id=de07d14e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de07d14e"]])

export default __exports__